module.exports = __webpack_public_path__ + "static/icons/person-7-8.5be510e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nps/person-7-8.svg
// module id = pMw7
// module chunks = 1